function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 41",
  transform: "translate(-760 -417)"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 7",
  cx: 36.5,
  cy: 35.5,
  rx: 36.5,
  ry: 35.5,
  transform: "translate(760 417)",
  fill: "#e8f6f4"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon metro-loop2",
  d: "M807.802 437.206a16.712 16.712 0 00-12.7-5.957c-9.506 0-17.212 8.21-17.212 18.338h3.233c0-8.229 6.261-14.9 13.985-14.9a13.588 13.588 0 0110.409 4.954l-5.032 5.361h11.833v-12.607zm1.288 12.381c0 8.229-6.261 14.9-13.985 14.9a13.588 13.588 0 01-10.41-4.954l5.028-5.362h-11.829v12.607l4.515-4.811a16.712 16.712 0 0012.7 5.957c9.506 0 17.212-8.21 17.212-18.338h-3.23z",
  fill: "#00a68d"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 8",
  transform: "translate(795.106 458)",
  fill: "#00a68d",
  stroke: "#e8f6f4",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "none"
})), /*#__PURE__*/React.createElement("text", {
  "data-name": 1,
  transform: "translate(802 472)",
  fill: "#e8f6f4",
  fontSize: 13,
  fontFamily: "WorkSans-Bold, Work Sans",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "1")));
var SvgOneRecurring = function SvgOneRecurring(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 71
  }, props), _ref);
};
export default SvgOneRecurring;